import { CryptoAsset, CryptoNetwork } from "@shared/types";

export const INVOICES_CRYPTO_ASSETS = [
  CryptoAsset.BTC,
  CryptoAsset.USDT,
  CryptoAsset.XRP,
];

export const AFFILIATION_CRYPTO_ASSETS = [CryptoAsset.USDT, CryptoAsset.XRP];

export const CRYPTO_ASSET_TO_DISPLAY = {
  [CryptoAsset.BTC]: "BTC",
  [CryptoAsset.USDT]: "USDT",
  [CryptoAsset.XRP]: "XRP",
};

export const CRYPTO_NETWORK_TO_DISPLAY = {
  [CryptoNetwork.ETH]: "ETH",
  [CryptoNetwork.TRX]: "TRX",
  [CryptoNetwork.BTC]: "BTC",
  [CryptoNetwork.XRP]: "XRP",
};

export const CRYPTO_ASSET_TO_NETWORKS = {
  [CryptoAsset.BTC]: [CryptoNetwork.BTC],
  [CryptoAsset.USDT]: [CryptoNetwork.ETH, CryptoNetwork.TRX],
  [CryptoAsset.XRP]: [CryptoNetwork.XRP],
};

export const BTC_REGEX = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;

export const ETH_REGEX = /^0x[a-fA-F0-9]{40}$/;

export const TRX_REGEX = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;

export const XRP_REGEX = /^r[1-9A-HJ-NP-Za-km-z]{24,34}$/;

export const MAX_XRP_TAG_VALUE = 4294967295;
